import script from "./UploadLinkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadLinkCard.vue?vue&type=script&setup=true&lang=js"

import "./UploadLinkCard.vue?vue&type=style&index=0&id=6fcfe8d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcfe8d4"]])

export default __exports__